import { render } from "./SponsorDonateListPage.vue?vue&type=template&id=5acf2971"
import script from "./SponsorDonateListPage.vue?vue&type=script&lang=js"
export * from "./SponsorDonateListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__